export default __webpack_public_path__ + "static/media/thumbnail_bundle.7eae5e83.png";